
















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class TabBar extends Vue {
    @Prop(String) classPrefix?: string;
    @Prop({required: true, type: Array}) bars!: TabBarItem[];
    @Prop({required: true, type: String}) cBar!: string;

    select(barValue: string) {
        this.$emit('update:cBar', barValue);
    }
}
